import React from 'react'
import { makeStyles } from 'tss-react/mui'
import { NumberField } from '@e3dc-react/shell/Elements/InputFields'
import { UnitTypes } from 'src/Libs/types'

const useStyles = makeStyles()(theme => ({
  numberField: {
    '& .MuiInputBase-input': {
      textAlign: 'right',
    },
    [theme.breakpoints.down('sm')]: {
      maxWidth: '150px',
    },
  },
}))

const MIN = 0
const MAX = 100

interface Props {
  value: number
  onChange: (value: number) => void
}

/**
 * Number Field component to select the minimum state of charge of the vehicle
 * Text is aligned to the right.
 */
const MinimumStateOfChargeNumberField: React.FC<Props> = ({ value, onChange }) => {
  const { classes } = useStyles()
  const handleChange = (value: number | ''): void => {
    onChange(value === '' ? 0 : value)
  }

  return <NumberField className={classes.numberField} value={value ?? 0} onChange={handleChange} min={MIN} max={MAX} suffix={UnitTypes.percentage} />
}

export default MinimumStateOfChargeNumberField
